import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _309fb986 = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _3ee4b841 = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _3273d8ef = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _433199be = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _64327838 = () => interopDefault(import('../pages/_market/_language/cart/index.vue'
/* webpackChunkName: "pages/_market/_language/cart/index" */
));

const _6f8b22c5 = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _013fd2bb = () => interopDefault(import('../pages/_market/_language/login/index.vue'
/* webpackChunkName: "pages/_market/_language/login/index" */
));

const _872ee494 = () => interopDefault(import('../pages/_market/_language/lost-password/index.vue'
/* webpackChunkName: "pages/_market/_language/lost-password/index" */
));

const _19aa00c6 = () => interopDefault(import('../pages/_market/_language/reset-password/index.vue'
/* webpackChunkName: "pages/_market/_language/reset-password/index" */
));

const _6280dd9c = () => interopDefault(import('../pages/_market/_language/signup/index.vue'
/* webpackChunkName: "pages/_market/_language/signup/index" */
));

const _1a154172 = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _e3e9b288 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _3232ca62 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _8694e21a = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _7e11e142 = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _2907739c = () => interopDefault(import('../pages/_market/_language/poc/grid.vue'
/* webpackChunkName: "pages/_market/_language/poc/grid" */
));

const _0a226030 = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _632a0f7d = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _242d1d69 = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _7da95e1e = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _79de78da = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

const _5acde820 = () => interopDefault(import('../pages/_market/_language/t/delivery.vue'
/* webpackChunkName: "pages/_market/_language/t/delivery" */
));

const _8a2b6ec6 = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

const _99093250 = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

const _3e3f9dba = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

const _0268df40 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

const _4b7e1984 = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

const _228e8fd8 = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

const _0215bed9 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _130febbb = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _7db99a34 = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _a5c9162e = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _033f8839 = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _3fe92f10 = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _3766dc47 = () => interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
));

const _81a45e58 = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _0b516f58 = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _d31de91a = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _af0b958c = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _76cda4e7 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _960980d2 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _5ee027e1 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _2ef487b3 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _de06ff04 = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _adf7795a = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _e199bbf6 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _15fc335e = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

const _dc3fe66e = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _b3b15912 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _309fb986,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _3ee4b841,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _3273d8ef,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _433199be,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _64327838,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _6f8b22c5,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _013fd2bb,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _872ee494,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _19aa00c6,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _6280dd9c,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _1a154172,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _e3e9b288,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _3232ca62,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _8694e21a,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _7e11e142,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _2907739c,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _0a226030,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _632a0f7d,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _242d1d69,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _7da95e1e,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _79de78da,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/delivery",
      component: _5acde820,
      name: "market-language-t-delivery"
    }, {
      path: "/:market/:language/t/login",
      component: _8a2b6ec6,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _99093250,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _3e3f9dba,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _0268df40,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _4b7e1984,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/signup",
      component: _228e8fd8,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _0215bed9,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _130febbb,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _7db99a34,
      children: [{
        path: "",
        component: _a5c9162e,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _033f8839,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _3fe92f10,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _3766dc47,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _81a45e58,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _0b516f58,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _d31de91a,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _af0b958c,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _76cda4e7,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _960980d2,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _5ee027e1,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _2ef487b3,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _de06ff04,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _adf7795a,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _e199bbf6,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _15fc335e,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _dc3fe66e,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _b3b15912,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}